<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="签约名称">
          <el-input placeholder="请输入签约名称" v-model="formInline.search"></el-input>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select v-model="formInline.status" placeholder="请选择审核状态" clearable>
            <el-option label="待审核" value="0"></el-option>
            <el-option label="审核通过" value="1"></el-option>
            <el-option label="审核拒绝" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="name" label="签约人"></el-table-column>
            <el-table-column prop="phone" label="电话"></el-table-column>
             <el-table-column prop="province" label="省"></el-table-column>
              <el-table-column prop="city" label="市"></el-table-column>
               <el-table-column prop="area" label="区"></el-table-column>
            <el-table-column prop="company" label="企业名称"></el-table-column>
            <el-table-column prop="sign_no" label="合同编号"></el-table-column>
            <el-table-column prop="sign_time" label="签约时间"></el-table-column>
            
            <!-- 审核状态列 -->
            <el-table-column prop="status" label="审核状态" width="100">
              <template slot-scope="scope">
                <el-tag 
                  :type="getStatusType(scope.row.status)" 
                  size="small"
                >
                  {{ getStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            
            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            
            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <!-- 审核操作按钮 -->
                <el-button 
                  v-if="scope.row.status == 0" 
                  @click="approveClick(scope.row)" 
                  type="text" 
                  size="small"
                  style="color: #67C23A;"
                    class="member-btn"
                >
                  通过
                    <span v-if="scope.row.is_read == 0" class="unread-dot-member"></span>
                </el-button>
                <el-button 
                  v-if="scope.row.status == 0" 
                  @click="rejectClick(scope.row)" 
                  type="text" 
                  size="small"
                  style="color: #F56C6C;"
                >
                  拒绝
                </el-button>
              
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    

    <!-- 审核对话框 -->
    <el-dialog
      :title="reviewDialogTitle"
      :visible.sync="reviewDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form :model="reviewForm" label-width="80px">
        <el-form-item label="审核不通过" v-if="reviewAction === 'reject'">
          <!-- <el-input
            type="textarea"
            :rows="4"
            v-model="reviewForm.remark"
            placeholder="请输入审核拒绝的理由"
          ></el-input> -->
        </el-form-item>
        <el-form-item label="提示" v-else>
          <span style="color: #67C23A;">确定要通过此签约申请吗？</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reviewDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmReview">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
      :close-on-click-modal="false" 
      :close-on-press-escape="false" 
      :append-to-body="true">
    </el-dialog>
  </div>
</template>

<script>
import Sign_upApi from '@/api/sign_up.js';
  import SupplyApi from '@/api/supply.js';

export default {
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search: "",
        status: "" // 审核状态筛选
      },

      open_add: false,
      open_edit: false,
      sign_up_id: "",
      dialogVisible: false,
      
      // 审核相关数据
      reviewDialogVisible: false,
      reviewAction: "", // 'approve' 或 'reject'
      currentReviewItem: null,
      reviewForm: {
        remark: ""
      }
    };
  },
  computed: {
    reviewDialogTitle() {
      return this.reviewAction === 'approve' ? '审核通过' : '审核拒绝';
    }
  },
  //  beforeDestroy(){
  //        SupplyApi.updateApplyRead({
  //     }).then(res=>{

  //     })
  //   },
  created() {
    /*获取列表*/
    this.getTableList();
    this.updateRead()
  },
  methods: {
    // 获取审核状态文本
    getStatusText(status) {
      const statusMap = {
        0: '待审核',
        1: '审核通过',
        2: '审核拒绝'
      };
      return statusMap[status] || '未知状态';
    },
     updateRead(){
      SupplyApi.updateRead({
       supply_id: this.supply_id,
       type:'17'
      }).then(res=>{
      })
    },
    
    // 获取审核状态标签类型
    getStatusType(status) {
      const typeMap = {
        0: 'warning',  // 待审核 - 黄色
        1: 'success',  // 审核通过 - 绿色
        2: 'danger'    // 审核拒绝 - 红色
      };
      return typeMap[status] || 'info';
    },
    
    dialogFormVisible() {
      this.dialogVisible = false;
    },
    
    setting(e) {
      this.dialogVisible = true;
    },
    
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    
    getData() {
      this.getTableList();
    },
    
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },
    
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    
    getTableList() {
      let self = this;
      let Params = {...this.formInline};
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      
      Sign_upApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },
    
    addClick() {
      this.open_add = true;
    },
    
    editClick(row) {
      this.sign_up_id = row.sign_up_id;
      this.open_edit = true;
    },
    
    // 审核通过
    approveClick(row) {
      this.currentReviewItem = row;
      this.reviewAction = 'approve';
      this.reviewForm.remark = '';
      this.reviewDialogVisible = true;
    },
    
    // 审核拒绝
    rejectClick(row) {
      this.currentReviewItem = row;
      this.reviewAction = 'reject';
      this.reviewForm.remark = '';
      this.reviewDialogVisible = true;
    },
    
    // 重置审核状态
    resetReviewClick(row) {
      this.$confirm('确定要重置此签约的审核状态吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.updateReviewStatus(row.sign_up_id, 0, '重置审核状态成功');
      });
    },
    
    // 确认审核操作
    confirmReview() {
      
      const status = this.reviewAction === 'approve' ? 1 : 2;
      this.updateReviewStatus(
        this.currentReviewItem.sign_up_id, 
        status, 
        `审核${this.reviewAction === 'approve' ? '通过' : '拒绝'}成功`
      );
    },
    
    // 更新审核状态
    updateReviewStatus(sign_up_id, status, successMessage) {
      Sign_upApi.review({
        sign_up_id: sign_up_id,
        status: status,
        remark: this.reviewForm.remark
      }, true)
      .then(data => {
        if (data.code == 1) {
          this.$message({
            message: successMessage,
            type: 'success'
          });
          this.reviewDialogVisible = false;
          this.getTableList(); // 刷新列表
        } else {
          this.$message.error(data.msg || '操作失败');
        }
      })
      .catch(error => {
        this.$message.error('操作失败');
      });
    },
    
    deleteClick(row) {
      let self = this;
      self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Sign_upApi.del({
          sign_up_id: row.sign_up_id
        }, true)
        .then(data => {
          if (data.code == 1) {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getTableList();
          } else {
            self.$message.error('错了哦，这是一条错误消息');
          }
        })
        .catch(error => {});
      }).catch(() => {});
    }
  }
};
</script>

<style>
.el-tag {
  margin: 2px;
}
 /* 可以根据需要添加样式 */
  .member-btn {
  position: relative;
}

/* 会员未读红点样式 */
.unread-dot-member {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  background-color: #ff4757;
  border-radius: 50%;
  animation: pulse 2s infinite;
}
</style>


// WEBPACK FOOTER //
// src/views/user/setting/part/Apply.vue